module.exports = __webpack_public_path__ + "img/setting.ab1b4a43.svg";